import { useEffect } from "react";

export interface BreadcrumbItem {
  name: string;
  url: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  currentPage: string;
}

/**
 * Breadcrumb component with visual navigation and JSON-LD schema
 * Includes structured data for search engines and visual navigation for users
 */
export function Breadcrumb({ items, currentPage }: BreadcrumbProps) {
  // Construct full breadcrumb chain with current page
  const fullBreadcrumbs = [...items, { name: currentPage, url: "" }];

  // Note: JSON-LD breadcrumb schema is handled by individual page Head.tsx files

  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      <ol className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
        {fullBreadcrumbs.map((item, index) => {
          const isLast = index === fullBreadcrumbs.length - 1;
          
          return (
            <li key={index} className="flex items-center gap-2">
              {index > 0 && (
                <svg 
                  className="w-4 h-4 text-gray-400 dark:text-gray-600" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              )}
              {isLast ? (
                <span 
                  className="font-medium text-gray-900 dark:text-gray-100" 
                  aria-current="page"
                >
                  {item.name}
                </span>
              ) : (
                <a
                  href={item.url}
                  className="hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
                  rel="follow index"
                >
                  {item.name}
                </a>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

